export const MODE_CACHE_KEY = 'CR_MODE';
export const LIGHT_MODE = 'light';
export const DARK_MODE = 'dark';
